module.exports = __webpack_public_path__ + "static/media/colorrbt_talk.fff02066.gif";